import { render, staticRenderFns } from "./DraggableResizeCombo.vue?vue&type=template&id=4bc3b4dc"
import script from "./DraggableResizeCombo.vue?vue&type=script&lang=ts"
export * from "./DraggableResizeCombo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc3b4dc')) {
      api.createRecord('4bc3b4dc', component.options)
    } else {
      api.reload('4bc3b4dc', component.options)
    }
    module.hot.accept("./DraggableResizeCombo.vue?vue&type=template&id=4bc3b4dc", function () {
      api.rerender('4bc3b4dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/DraggableResizeCombo.vue"
export default component.exports